// extracted by mini-css-extract-plugin
module.exports = {"jobPostInline":"bp_dB","jobPost":"bp_dC","jobTitle":"bp_dD","jobLocation":"bp_dF","jobPostBorder":"bp_dG"};